// Mock data for Pandit C. S. Joshi — Astrologer Site
// NOTE: Reviews are MOCKED with realistic Google Maps style data because
// real-time Google Reviews import requires a paid Google Places API key.
// A "View All on Google" button links to the actual Google Maps page.

export const CONTACT = {
  name: "Pandit C. S. Joshi",
  callNumber: "+918105930286",
  callDisplay: "+91 81059 30286",
  whatsappNumber: "+919740059741",
  whatsappDisplay: "+91 97400 59741",
  email: "Chetansharma81034@gmail.com",
  googleMapsLink: "https://share.google/USgH41AuXlT1HdBGu",
  address: "Sri Sai Raghvendra Astro, Vinayaka Jewellers, Katte Vinayaka Swamy Temple Front, beside KR Puram, Krishnarajapuram, Bengaluru, Karnataka 560036",
  hours: "Mon – Sun · 9:00 AM – 8:00 PM IST",
  youtubeShortId: "z0bVA7FoZAw",
  // ⚠️ EDIT THIS — the email where consultation form submissions will be delivered.
  // Use your Hostinger business email (which forwards to your personal mail).
  // First submission triggers a one-time activation email from FormSubmit — click the link to confirm.
  formEmail: "csjoshi@srisairaghvendraastro.com",
};

export const HERO_STATS = [
  { num: "18+",     label: "Years Experience" },
  { num: "82,000+", label: "Clients Served" },
  { num: "100%",    label: "Genuine Solutions" },
  { num: "4.8 ★",   label: "Google Rating" },
];

export const SERVICES = [
  { id: 1, title: "Palmistry Reading",    icon: "fa-hand",            img: "/images/Palmistry_Reading.jpg",
    desc: "Unlock the secrets of your past, present and future through expert palm-line analysis by Guruji." },
  { id: 2, title: "Love & Marriage",      icon: "fa-heart",           img: "/images/Love_a_Marriage.jpg",
    desc: "Expert guidance for love problems, marriage delays, relationship conflicts and compatibility matching." },
  { id: 3, title: "Horoscope Reading",    icon: "fa-scroll",          img: "/images/Horoscope_Reading.jpg",
    desc: "Detailed birth chart analysis offering clarity on career, health, wealth and personal milestones." },
  { id: 4, title: "Vastu Consultation",   icon: "fa-house-chimney",   img: "/images/Vastu_Consultation.jpg",
    desc: "Align your living and working spaces with cosmic energies for peace, prosperity and progress." },
  { id: 5, title: "Black Magic Removal",  icon: "fa-skull-crossbones",img: "/images/Black_Magic_Removal.jpg",
    desc: "Powerful spiritual rituals invoking Maa Durga, Lord Hanuman and Lord Bhairav to remove negative forces." },
  { id: 6, title: "Career & Finance",     icon: "fa-briefcase",       img: "/images/Career_a_Finance.jpg",
    desc: "Overcome professional obstacles and financial challenges with targeted astrological remedies." },
  { id: 7, title: "Family Problems",      icon: "fa-people-roof",     img: "/images/Family_Problems.jpg",
    desc: "Restore harmony, unity and mutual understanding in family relationships through spiritual guidance." },
  { id: 8, title: "Negative Energy",      icon: "fa-bolt",            img: "/images/Negative_Energy.jpg",
    desc: "Cleanse your aura and living space of harmful energies, restoring positivity and mental peace." },
];

export const HOMAS = [
  { num: "01", title: "Ganesh Homa",          tag: "Obstacle Removal",   img: "/images/Ganesh_Homa.jpg",
    desc: "Performed to remove life obstacles, attract happiness and bring prosperity and good health into your home." },
  { num: "02", title: "Kubera Lakshmi Homa",  tag: "Wealth & Abundance", img: "/images/Kubera_Lakshmi_Homa.jpg",
    desc: "Invokes Goddess Lakshmi Devi and Lord Kubera to bless you with wealth, abundance and lasting financial stability." },
  { num: "03", title: "Navagraha Pooja",      tag: "Planetary Balance",  img: "/images/Navagraha_Pooja.jpg",
    desc: "Worship of all nine planetary deities for cosmic harmony and balanced planetary influence in life." },
  { num: "04", title: "KaalSarp Dosha Pooja", tag: "Dosha Removal",      img: "/images/KaalSarp_Dosha_Pooja.jpg",
    desc: "Powerful Homam to remove the ill effects of Kala Sarpa Dosha from the horoscope through Nagadevata worship." },
  { num: "05", title: "Dhanvantari Homa",     tag: "Health & Healing",   img: "/images/Dhanvantari_Homa.jpg",
    desc: "Invokes Lord Dhanvantari's divine blessings for good health, healing, prosperity and long life for the family." },
  { num: "06", title: "Manglik Dosha Parihar",tag: "Marriage Harmony",   img: "/images/Manglik_Dosha_Parihar.jpg",
    desc: "Neutralizes the negative effects of Mangala Dosha that impacts professional and marital life, restoring harmony." },
];

export const ZODIACS = [
  { name: "Aries",       sign: "Mar 21 – Apr 19", img: "/images/ARIES.png" },
  { name: "Taurus",      sign: "Apr 20 – May 20", img: "/images/taurus.png" },
  { name: "Gemini",      sign: "May 21 – Jun 20", img: "/images/Gemini.png" },
  { name: "Cancer",      sign: "Jun 21 – Jul 22", img: "/images/cancer.png" },
  { name: "Leo",         sign: "Jul 23 – Aug 22", img: "/images/leo.png" },
  { name: "Virgo",       sign: "Aug 23 – Sep 22", img: "/images/virgo.png" },
  { name: "Libra",       sign: "Sep 23 – Oct 22", img: "/images/libra.png" },
  { name: "Scorpio",     sign: "Oct 23 – Nov 21", img: "/images/scorpio.png" },
  { name: "Sagittarius", sign: "Nov 22 – Dec 21", img: "/images/Sagitarius.png" },
  { name: "Capricorn",   sign: "Dec 22 – Jan 19", img: "/images/Capricornus.png" },
  { name: "Aquarius",    sign: "Jan 20 – Feb 18", img: "/images/Aquarius.png" },
  { name: "Pisces",      sign: "Feb 19 – Mar 20", img: "/images/pisces.png" },
];

export const COUNTERS = [
  { target: 108456, suffix: "+", label: "Clients Served" },
  { target: 54000,  suffix: "+", label: "Kundali Matched" },
  { target: 25645,  suffix: "+", label: "Vastu Consultations" },
  { target: 18,     suffix: "+", label: "Years of Experience" },
  { target: 6,      suffix: "+", label: "Languages Known" },
];

export const WHY_REASONS = [
  { icon: "fa-bullseye",      title: "Accurate Predictions",
    desc: "Guruji's readings are grounded in authentic Vedic methodology, delivering clarity and reliability in every consultation." },
  { icon: "fa-check-double",  title: "Only Genuine Solutions",
    desc: "No false claims, no exaggerated promises. Guruji provides practical, ethical and honest spiritual guidance only." },
  { icon: "fa-award",         title: "Most Trusted Astrologer",
    desc: "Thousands of clients across Bangalore and beyond trust Guruji for life's most important decisions." },
  { icon: "fa-om",            title: "Vedic Astrology Solutions",
    desc: "Deep expertise in Vedic astrology, Nadi, palmistry, numerology and spiritual remedies rooted in ancient wisdom." },
  { icon: "fa-user-shield",   title: "Confidential & Ethical",
    desc: "All personal information and consultations remain strictly private. Your trust is Guruji's highest responsibility." },
  { icon: "fa-phone-volume",  title: "Available Online Too",
    desc: "Phone, video and online consultations available for clients across India and around the world." },
];

// MOCKED Google Reviews — 10 entries (carousel)
export const REVIEWS = [
  { name: "Ravi Kumar",      city: "Bengaluru",   stars: 5, color: "#4285F4",
    text: "I was facing career and financial problems for years. After consulting Pandit C. S. Joshi Guruji, I received such clear guidance. Within months, my business improved dramatically. Highly recommend!" },
  { name: "Priya Sharma",    city: "KR Puram",    stars: 5, color: "#E94336",
    text: "Guruji's palmistry reading was astonishing — he described events from my past accurately without me saying anything. His remedies for my marriage problems worked wonderfully. Truly gifted!" },
  { name: "Suresh Naidu",    city: "Whitefield",  stars: 5, color: "#34A853",
    text: "Very honest and genuine astrologer. No false promises, only real solutions. Guruji helped us with our Kundali matching and Navagraha Pooja. Feeling much more peaceful and positive now." },
  { name: "Anitha Reddy",    city: "Dubai",       stars: 5, color: "#FBBC05",
    text: "I consulted Guruji online from Dubai. He was incredibly thorough and the remedies he suggested for my family problems resolved years of conflict. Blessed to have found him!" },
  { name: "Mahesh Gowda",    city: "Bangalore",   stars: 5, color: "#874B78",
    text: "The Ganesh Homa performed by Guruji transformed our home environment completely. Obstacles that had been blocking our path for 3 years cleared up in just 2 months. Absolutely miraculous!" },
  { name: "Vinay Prasad",    city: "Jayanagar",   stars: 5, color: "#E19696",
    text: "KaalSarp Dosha Pooja by Guruji changed my life. I had been suffering from repeated failures for years. After the pooja, I got a promotion and my health improved. Eternally grateful." },
  { name: "Lakshmi Iyer",    city: "Chennai",     stars: 5, color: "#1E88E5",
    text: "Online consultation was as effective as in-person. Guruji read my Kundali and shared insights about my children's careers that have already proven correct. Five stars without hesitation." },
  { name: "Rohit Mehra",     city: "Delhi",       stars: 4, color: "#43A047",
    text: "Honest astrologer with practical advice. Did not push me into unnecessary poojas. The remedies for my Mangal Dosha are showing visible improvements in my marital life." },
  { name: "Kavya Nair",      city: "Marathahalli",stars: 5, color: "#C8973A",
    text: "Vastu consultation for our new home was so detailed. Guruji explained why energy was stuck in certain rooms and the corrections he suggested have made a huge difference in our peace." },
  { name: "Arjun Hegde",     city: "Mangalore",   stars: 5, color: "#5C3556",
    text: "Pandit ji's love & relationship guidance saved my marriage. He pointed out planetary issues that I had no idea about and the parihar puja was conducted with such authenticity." },
];

export const FAQS = [
  { q: "How accurate are Guruji's predictions?",
    a: "Guruji's predictions are based on traditional Vedic methodology honed over 18+ years of practice. Many clients have described his readings as remarkably accurate, with specific life events predicted with great clarity." },
  { q: "Is the first consultation really free?",
    a: "Yes! Your very first call with Pandit C. S. Joshi Guruji is completely free. This allows you to experience Guruji's guidance and decide if you'd like to proceed further." },
  { q: "What details do I need for a consultation?",
    a: "Please provide your full date of birth, exact time of birth, and place of birth. These are required for precise Kundali analysis and accurate readings." },
  { q: "Are online consultations available?",
    a: "Absolutely. Guruji offers phone and video consultations for clients across India and worldwide. You don't need to visit in person to receive full guidance." },
  { q: "What kind of remedies does Guruji suggest?",
    a: "Remedies may include gemstones, mantras, pujas, homas or specific rituals — all tailored to your horoscope. Guruji only recommends practical and ethical solutions." },
  { q: "Is my information kept confidential?",
    a: "Absolutely. All personal details and consultation discussions are held in the strictest confidence. Your privacy is Guruji's top priority." },
];

export const TICKER_ITEMS = [
  "No.1 Astrologer in Bangalore",
  "Expert in Vedic Astrology",
  "KR Puram's Most Trusted Guruji",
  "Black Magic Removal Specialist",
  "Accurate Horoscope Readings",
  "18+ Years of Experience",
  "Free First Consultation Available",
  "82,000+ Happy Clients Served",
];
